import gql from 'graphql-tag'

const getAccountingLabels = gql`
query getAppConfig {
	cashAssist {
		getAppConfig {
            creditCards
            specialProductExpenses
            currencyNames
        }
	}
}
`

export default getAccountingLabels
